import { IMessageDescription } from "./common";

// COMMON
export const RECORD_FOUND: IMessageDescription = { code: 1000, message: "Data found" };
export const NO_RECORD_FOUND: IMessageDescription = { code: 1001, message: "Data not found" };
export const VALIDATIONS_ERROR: IMessageDescription = { code: 1003 };
export const UNEXPECTED_ERROR: IMessageDescription = { code: 1004 };

// USER
export const USER_SETTINGS_UPDATED: IMessageDescription = { code: 2033 };

// TOKEN
export const TOKEN_EXPIRED: IMessageDescription = { code: 1006 };
export const UNAUTHORISEDUSER: IMessageDescription = { code: 1005 };
export const AUTHENTICATION_SUCCESS: IMessageDescription = { code: 2004 };
export const AUTHENTICATION_FAILED: IMessageDescription = { code: 2005 };

// FARM
export const FARM_ACTIVATED: IMessageDescription = { code: 2016 };
export const FARM_SWITCHED: IMessageDescription = { code: 2018 };

// EQUIPMENT
export const EQUIPMENT_CREATED: IMessageDescription = { code: 4000 };
export const EQUIPMENT_EDITED: IMessageDescription = { code: 4002 };
export const EQUIPMENT_DELETED: IMessageDescription = { code: 4004 };

// EQUIPMENT GROUP
export const EQUIPMENT_GROUP_CREATED: IMessageDescription = { code: 4006 };
export const EQUIPMENT_GROUP_EDITED: IMessageDescription = { code: 4009 };
export const EQUIPMENT_GROUP_DELETED: IMessageDescription = { code: 4011 };

// CREW
export const CREW_CREATED: IMessageDescription = { code: 5000 };
export const CREW_EDITED: IMessageDescription = { code: 5002 };
export const CREW_DELETED: IMessageDescription = { code: 5004 };

// PERSON
export const PERSONAL_CREATED: IMessageDescription = { code: 2051 };
export const PERSONAL_EDITED: IMessageDescription = { code: 2053 };
export const PERSONAL_DELETED: IMessageDescription = { code: 2055 };

// MAP
export const NO_EG_FOUND: IMessageDescription = { message: "No equipment group(s) found" };

// REPORT
export const REPORT_GENERATED: IMessageDescription = { code: 6000 };

// LOAD
export const LOAD_APPROVED: IMessageDescription = { code: 4023, message: "Load approved successfully" };
